// Símbolo da marca VORTEK: um vórtice (3 arcos girando + eixo central).
// Usado nos tiles da plataforma (login + sidebar do Operador). A cor é passada
// por prop pra contrastar com o fundo do tile (dourado ou escuro).
export function LogoVortek({ size = 32, color = "#C9A55C" }: { size?: number; color?: string }) {
  return (
    <svg width={size} height={size} viewBox="0 0 72 72" fill="none" aria-hidden="true">
      <path d="M24 15 A24 24 0 0 1 57 48" stroke={color} strokeWidth="6" strokeLinecap="round" />
      <path d="M28 22 A16 16 0 0 1 50 44" stroke={color} strokeWidth="6" strokeLinecap="round" />
      <path d="M32 29 A8 8 0 0 1 43 40" stroke={color} strokeWidth="6" strokeLinecap="round" />
      <circle cx="36" cy="36" r="3.5" fill={color} />
    </svg>
  );
}
